import {
	StyleSheet,
	FlatList,
	View,
	SafeAreaView,
	Text,
	Pressable,
	ScrollView,
} from "react-native";
import HighlightedDiscountsRail from "../../../components/HighlightedDiscountsRail";
import React, { useEffect, useState } from "react";
import DiscountsForYouRail from "../../../components/DiscountsForYouRail";
import FoodDiscountsRail from "../../../components/FoodDiscountsRail";
import AllDiscounts from "./AllDiscounts";
import useApi from "../../../hooks/useAPI";
import { useQuery } from "react-query";
import { useTheme, Menu, Button, Divider, Provider } from "react-native-paper";
import { Entypo } from "@expo/vector-icons";
import DropdownButton from "./DropdownButton";

export interface Filters {
	category: string;
	region: string;
	isicType: string;
	storeType: string;
}
export enum categoriesFilter {
	isicType = "isicType",
	category = "category",
	region = "region",
	storeType = "storeType",
}
const FilterBar = ({ selectedFilters, setSelectedFilters }) => {
	const { colors } = useTheme();
	const [selectedCategory, setSelectedCategory] = useState("Todos");

	const setSelectedFilter = (filter: keyof Filters, value: string) => {
		setSelectedFilters({
			...selectedFilters,
			[filter]: value,
			showRails: true,
		});
	};
	const [visible, setVisible] = useState(false);

	const openMenu = () => setVisible(true);

	const closeMenu = () => setVisible(false);
	const staticCategories = [
		{ name: "Todos" },
		{
			name: "Região",
			subCategories: ["Nacional", "Internacional", "Todas"],
			type: categoriesFilter.region,
		},
		{
			name: "Tipo",
			subCategories: ["Loja Online", "Loja Física", "Todas"],
			type: categoriesFilter.storeType,
		},
		{
			name: "Categoria",
			subCategories: [
				"Cultura",
				"Alimentação",
				"Eletrônicos",
				"Cursos e EAD",
				"Entretenimento",
				"Viagens",
				"Serviços",
				"Livraria e Papelaria",
				"Saúde e Beleza",
				"Todas",
			],
			type: categoriesFilter.category,
		},
		// { name: "Cultura", type: categoriesFilter.category },
		// { name: "Alimentação", type: categoriesFilter.category },
		// { name: "Eletrônicos", type: categoriesFilter.category },
		// { name: "Cursos e EAD", type: categoriesFilter.category },
		// { name: "Entretenimento", type: categoriesFilter.category },
	];
	return (
		<View>
			<ScrollView
				horizontal={true}
				style={[
					styles.filter,
					{
						backgroundColor: colors.figmaBackgroundColor,
						flexDirection: "row",
						//height: "100%",
					},
				]}
			>
				{staticCategories.map((item, index) => {
					return (
						<View style={{ zIndex: 100, marginBottom: 18 }}>
							{item.subCategories ? (
								<DropdownButton
									item={item}
									selectedCategory={selectedCategory}
									setSelectedCategory={setSelectedCategory}
									setSelectedFilter={setSelectedFilter}
									selectedFilters={selectedFilters}
								/>
							) : (
								<Pressable
									onPress={() => {
										setSelectedCategory(item.name);
										if (item.name === "Todos") {
											setSelectedFilter("category", "Todas");
										} else {
											setSelectedFilter(item.type, item.name);
										}
									}}
									style={[
										styles.item,
										{
											marginLeft: index === 0 ? 24 : 0,
											backgroundColor:
												selectedCategory === item.name
													? colors.pureWhite
													: colors.figmaBackgroundColor,
											borderWidth: 1,
											borderColor:
												selectedCategory === item.name
													? colors.figmaBackgroundColor
													: colors.pureWhite,
										},
									]}
								>
									<Text
										style={[
											styles.itemName,
											{
												color:
													selectedCategory === item.name
														? colors.figmaBackgroundColor
														: colors.pureWhite,
											},
										]}
									>
										{item.name}
									</Text>
								</Pressable>
							)}
						</View>
					);
				})}
			</ScrollView>
		</View>
	);
};
export default FilterBar;
const styles = StyleSheet.create({
	container: { zIndex: 1 },

	filter: { paddingTop: 10 },
	itemName: {
		color: "#00f",
		fontFamily: "DmSans",
	},
	item: {
		height: 37,
		marginHorizontal: 10,
		paddingHorizontal: 20,
		alignItems: "center",
		backgroundColor: "#fff",
		alignSelf: "center",
		borderRadius: 25,
		flexDirection: "row",
		zIndex: 5,
	},
});
